import React from "react";
import { Link } from "react-router-dom";
import {
  FaCloud,
  FaServer,
  FaShoppingCart,
  FaUtensils,
  FaCode,
  FaRocket,
  FaExternalLinkAlt,
} from "react-icons/fa";
import profile from "../../data/profile";

const iconMap = {
  FaCloud: <FaCloud />,
  FaServer: <FaServer />,
  FaShoppingCart: <FaShoppingCart />,
  FaUtensils: <FaUtensils />,
  FaCode: <FaCode />,
};

function FeaturedProjects() {
  const featured = profile.projects.slice(0, 4);
  return (
    <section className="glass-card">
      <h2 className="section-title">
        <FaRocket /> Featured Projects
      </h2>
      <div className="projects-grid">
        {featured.map((project, i) => (
          <div className="project-card glass-card" key={i}>
            <div className="project-content">
              <div className="project-icon" style={{ color: project.color }}>
                {iconMap[project.icon]}
              </div>
              <h3>{project.name}</h3>
              <div className="project-tech">
                {project.tech.map((t) => (
                  <span key={t}>{t}</span>
                ))}
              </div>
              <p>{project.description}</p>
            </div>
            {project.url ? (
              <a
                href={project.url}
                target="_blank"
                rel="noreferrer"
                className="btn btn-outline"
              >
                <FaExternalLinkAlt /> Live Demo
              </a>
            ) : (
              <Link to="/project" className="btn btn-outline">
                View Details
              </Link>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}

export default FeaturedProjects;